import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";

// Renders a Google AdSense responsive ad unit inline (works only if
// admin has set adsense_client_id and adsense_slot_article in site-settings).
export default function InArticleAd() {
  const [conf, setConf] = useState(null);
  const insRef = useRef(null);

  useEffect(() => {
    let mounted = true;
    api.get("/site-info").then((r) => {
      if (!mounted) return;
      const client = (r.data?.adsense_client_id || "").trim();
      const slot = (r.data?.adsense_slot_article || "").trim();
      if (client && slot) setConf({ client, slot });
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    if (!conf || !insRef.current) return;
    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) { console.error("AdSense push failed:", e); }
  }, [conf]);

  if (!conf) return null;
  return (
    <div className="my-6" data-testid="in-article-ad">
      <div className="text-[9px] uppercase tracking-widest text-slate-400 font-admin mb-1 text-center">विज्ञापन · Advertisement</div>
      <ins ref={insRef}
        className="adsbygoogle"
        style={{ display: "block", textAlign: "center" }}
        data-ad-layout="in-article"
        data-ad-format="fluid"
        data-ad-client={conf.client}
        data-ad-slot={conf.slot}></ins>
    </div>
  );
}
